
import { CreditCard } from "lucide-react";

export type IconType = {
  type: "lucide" | "image";
  name?: string;
  src?: string;
  alt?: string;
  props?: Record<string, any>;
};

export type PaymentMethod = {
  id: string;
  name: string;
  icon: IconType;
  description: string;
  countryAvailability?: string[];
};

export const getPaymentMethods = (userCountry: string) => {
  const paymentMethods: PaymentMethod[] = [
    {
      id: "card",
      name: "Credit/Debit Card",
      icon: {
        type: "lucide",
        name: "CreditCard",
        props: { className: "h-6 w-6 text-blue-500" }
      },
      description: "Pay securely with your credit or debit card"
    },
    {
      id: "mpesa",
      name: "M-Pesa",
      icon: {
        type: "image",
        src: "/lovable-uploads/28080e56-5e4f-4e0c-aa46-2ecbc4307021.png",
        alt: "M-Pesa logo",
        props: { className: "h-8 w-auto" }
      },
      description: "Pay using M-Pesa mobile money",
      countryAvailability: ["Kenya"]
    },
    {
      id: "chapa",
      name: "Chapa",
      icon: {
        type: "image",
        src: "/lovable-uploads/d6608050-7b00-4c9b-afc3-097db6ebf992.png",
        alt: "Chapa logo",
        props: { className: "h-8 w-auto" }
      },
      description: "Pay with Chapa (available in Ethiopia)",
      countryAvailability: ["Ethiopia"]
    }
  ];

  return paymentMethods.filter(method => {
    // If the method has country restrictions, check if user's country is in the list
    if (method.countryAvailability) {
      return method.countryAvailability.includes(userCountry) || method.id === "card";
    }
    // Otherwise, include the payment method
    return true;
  });
};
